import { Outlet } from "react-router-dom"
import useAuth from "../hooks/useAuth";
import { useLayoutEffect } from "react";
import axios from "axios";
import Navbar from "../components/navbar";
import Footer from "../components/footer";


const Layout = () => {
    const { auth, setAuth, Loading, setLoading } = useAuth();
    console.log(process.env.REACT_APP_HOST1);

    useLayoutEffect(() => {
        const authCheck = async () => {
            setLoading(true);
            console.log(localStorage.getItem("accessToken"))

            try {
                /* =============== HERE CALL MY API CHECK =============== */

                await axios
                    .get(`${process.env.REACT_APP_HOST1}/auth/auth`, {
                        headers: {
                            "Content-Type": "application/json",
                            accessToken: localStorage.getItem("accessToken")//bad practise
                        },
                    })
                    .then((response) => {
                        if (response.data.error) {
                            setAuth({ ...auth, status: false }); //spread operator (...) is used to create a new object that is a shallow copy of the auth object
                        } else {
                            console.log(response.data.status);
                            setAuth({
                                name: response.data.name,
                                id: response.data.id,
                                status: response.data.status,
                            });

                        }
                    });
            } catch (error) {
                // handle any Promise rejections, errors, etc...
                setAuth({ ...auth, status: false }); // or unauthorized value
            } finally {
                setLoading(false);
            }
        };

        authCheck();

        return () => {
            // cancel/clean up any pending/in-flight asynchronous auth checks
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []); // <-- check authentication on mount only

    if (Loading) {
        return null; // or loading spinner, etc...
    }


    return (<div className="wrapper"><Navbar/>
        {Loading === false ? <Outlet />  : null    }<Footer/></div>
    )
}

export default Layout;